import { render, staticRenderFns } from "./tableDetailAccommodation.vue?vue&type=template&id=3677c11a&scoped=true"
import script from "./tableDetailAccommodation.vue?vue&type=script&lang=js"
export * from "./tableDetailAccommodation.vue?vue&type=script&lang=js"
import style0 from "./tableDetailAccommodation.vue?vue&type=style&index=0&id=3677c11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3677c11a",
  null
  
)

export default component.exports